import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bb6ae2a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "CommonButton" }

import { computed } from '@vue/reactivity';
import Text from '@/components/common/TextComponent.vue'
import { COLOR_SET, FONT_SIZE, FONT_WEIGHT } from '@/styles/variables'


export default /*#__PURE__*/_defineComponent({
  name: 'Button',
  props: {
    text: null,
    width: { default: undefined },
    height: { default: undefined },
    disabled: { type: Boolean },
    noButton: { type: Boolean },
    fontSize: { default: FONT_SIZE.lg },
    weight: { default: FONT_WEIGHT.regular },
    mobileEffect: { type: Boolean },
    maxWidth: { default: undefined },
    hasBackground: { type: Boolean }
  },
  emits: ["button_click"],
  setup(__props: any) {

const props = __props as { text: string, width: string, height: string, disabled?: boolean, noButton?: boolean, fontSize: string, weight: string, mobileEffect?: boolean, maxWidth: string, hasBackground?: boolean }

_useCssVars(_ctx => ({
  "3ecd4a7e": (_unref(bgColor)),
  "4ad99ff8": (_unref(hoverColor))
}))





const bgColor = computed(() => props.hasBackground ? COLOR_SET.white : COLOR_SET.blue01)
const hoverColor = computed(() => props.hasBackground ? COLOR_SET.white : '#3C4FF8')
const color = computed(() => props.hasBackground ? COLOR_SET.gray01 : COLOR_SET.white)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["wrapper button", {
        'disabled': __props.disabled,
        'no-button': __props.noButton,
        'mobile-effect': __props.mobileEffect,
      }]),
      style: _normalizeStyle({'width': __props.width, 'height': __props.height, 'max-width': __props.maxWidth }),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.disabled ? undefined : _ctx.$emit('button_click')))
    }, [
      _createVNode(Text, {
        size: __props.fontSize,
        color: __props.noButton ? _unref(COLOR_SET).gray03 : _unref(color),
        "mobile-color": __props.noButton ? _unref(COLOR_SET).gray03 : _unref(COLOR_SET).white,
        weight: __props.weight
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.text), 1)
        ]),
        _: 1
      }, 8, ["size", "color", "mobile-color", "weight"])
    ], 6)
  ]))
}
}

})